import React from 'react'
import { Row, Col, Skeleton } from 'antd'

export default function SkeletonTestCaseForm() {
    return (
        <div
            style={{
                maxWidth: 700,
                margin: '0 auto',
                paddingLeft: 20,
                paddingRight: 20,
                paddingTop: 20,
                background: '#fff',
                borderRadius: 8,
            }}
        >
            {/* Title */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={6}>
                    <Skeleton.Input active size="small" style={{ width: 80 }} />
                </Col>
                <Col span={18}>
                    <Skeleton.Input active block />
                </Col>
            </Row>

            {/* ID */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={6}>
                    <Skeleton.Input active size="small" style={{ width: 40 }} />
                </Col>
                <Col span={18}>
                    <Skeleton.Input active block />
                </Col>
            </Row>

            {/* Preconditions (textarea) */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={6}>
                    <Skeleton.Input
                        active
                        size="small"
                        style={{ width: 110 }}
                    />
                </Col>
                <Col span={18}>
                    <Skeleton.Input active block style={{ height: 88 }} />
                </Col>
            </Row>

            {/* Test Data */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={6}>
                    <Skeleton.Input active size="small" style={{ width: 80 }} />
                </Col>
                <Col span={18}>
                    <Skeleton.Input active block style={{ height: 88 }} />
                </Col>
            </Row>

            {/* Steps */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={6}>
                    <Skeleton.Input active size="small" style={{ width: 60 }} />
                </Col>
                <Col span={18}>
                    <Skeleton.Input active block style={{ height: 88 }} />
                </Col>
            </Row>

            {/* Description */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={6}>
                    <Skeleton.Input active size="small" style={{ width: 90 }} />
                </Col>
                <Col span={18}>
                    <Skeleton.Input active block style={{ height: 88 }} />
                </Col>
            </Row>

            {/* Expected Result */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={6}>
                    <Skeleton.Input
                        active
                        size="small"
                        style={{ width: 120 }}
                    />
                </Col>
                <Col span={18}>
                    <Skeleton.Input active block style={{ height: 88 }} />
                </Col>
            </Row>

            {/* Epic (select) */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={6}>
                    <Skeleton.Input active size="small" style={{ width: 50 }} />
                </Col>
                <Col span={18}>
                    <Skeleton.Input active block style={{ height: 38 }} />
                </Col>
            </Row>

            {/* Sprint (select) */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={6}>
                    <Skeleton.Input active size="small" style={{ width: 60 }} />
                </Col>
                <Col span={18}>
                    <Skeleton.Input active block style={{ height: 38 }} />
                </Col>
            </Row>

            {/* Tags (multi-select) */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={6}>
                    <Skeleton.Input active size="small" style={{ width: 50 }} />
                </Col>
                <Col span={18}>
                    <Skeleton.Input active block style={{ height: 38 }} />
                </Col>
            </Row>

            {/* Sticky footer skeleton buttons */}
            <div
                style={{
                    position: 'sticky',
                    bottom: 0,
                    background: '#fff',
                    padding: '10px 0',
                    borderTop: '1px solid #f0f0f0',
                    width: '100%',
                    zIndex: 99,
                }}
            >
                <div
                    style={{ display: 'flex', justifyContent: 'end', gap: 10 }}
                >
                    <Skeleton.Button active style={{ width: 80 }} />
                    <Skeleton.Button active style={{ width: 110 }} />
                    <Skeleton.Button active style={{ width: 80 }} />
                </div>
            </div>
        </div>
    )
}
